export const isMinFloat = (value: number, min: number) => typeof value === "number" && value >= min

export const isMaxFloat = (value: number, max: number) => typeof value === "number" && value <= max

export const isValidPrice = (value: number, min = 0.0, max = 9999.99) =>
	isMinFloat(value, min) && isMaxFloat(value, max)
